import { type SelectChangeEvent } from '@mui/material'
import { Box } from '@mui/system'
import { type ITabOption, Tabs } from 'components'
import { color } from 'config/color'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { UsageViewGraph } from './UsageViewGraph'

const DEFAULT_FILTER = {
  activeTab: 0,
  monthly: dayjs().year(),
  daily: dayjs().format('YYYY-MM'),
  hourly: dayjs().format('YYYY-MM-DD')
}

const DEFAULT_SERVICE_FILTERS = {
  electric: {
    ...DEFAULT_FILTER
  },
  water: {
    ...DEFAULT_FILTER
  },
  gas: {
    ...DEFAULT_FILTER
  }
}
const getUsageViewTabOptions = (
  serviceType: string,
  filters: any,
  setFilters: any
): ITabOption[] => [
    {
      title: 'Monthly View',
      content: (
        <UsageViewGraph
          serviceType={serviceType}
          filters={filters}
          setFilters={setFilters}
          viewType="monthly"
        />
      )
    },
    {
      title: 'Daily View',
      content: (
        <UsageViewGraph
          serviceType={serviceType}
          filters={filters}
          setFilters={setFilters}
          viewType="daily"
        />
      )
    },
    {
      title: 'Hourly View',
      content: (
        <UsageViewGraph
          serviceType={serviceType}
          filters={filters}
          setFilters={setFilters}
          viewType="hourly"
        />
      )
    }
  ]

interface IUsageView {
  serviceType: string
}

export const UsageView = ({ serviceType }: IUsageView): JSX.Element => {
  const [filters, setFilters] = useState<
    Record<string, Record<string, any>>
  >(DEFAULT_SERVICE_FILTERS)

  const [activeTab, setActiveTab] = useState<number>(0)

  const handleTabChange = (_e: any, newActiveTab: number): void => {
    setFilters({
      ...filters,
      [serviceType]: { ...filters[serviceType], activeTab: newActiveTab }
    })
    setActiveTab(newActiveTab)
  }
  const handleSelectChange = (event: SelectChangeEvent): void => {
    setFilters({
      ...filters,
      [serviceType]: {
        ...filters[serviceType],
        activeTab: Number(event.target.value)
      }
    })
    setActiveTab(Number(event.target.value))
  }

  useEffect(() => {
    setActiveTab(Number(filters[serviceType].activeTab))
  }, [filters, serviceType])

  return (
    <Box bgcolor={color.white} mt={3}>
      {false && <Tabs
        activeTab={activeTab}
        handleTabChange={handleTabChange}
        handleSelectChange={handleSelectChange}
        tabOptions={getUsageViewTabOptions(serviceType, filters, setFilters)}
      />}
      <UsageViewGraph
        serviceType={serviceType}
        filters={filters}
        setFilters={setFilters}
        viewType="monthly"
      />
    </Box>
  )
}
